import React, { useContext, useEffect } from "react";
import { Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import Auth from "./pages/auth/Auth";
import AuthCalendar from "./pages/authCalendar/authCalendar.jsx";
import TaskTable from "./components/tashTable/TaskTable";
import Sidebar from "./components/sidebar/Sidebar";
import DashboardHome from "./pages/dashboardHome/dashboardHome.jsx";
import { Toaster } from "react-hot-toast";
import UserContext from "./context/autnContext.js";
function App() {
  const location = useLocation();
  const { user } = useContext(UserContext);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    if (token) {
      Cookies.set("token", token);
      window.history.replaceState(
        {},
        document.title,
        "/slack/dashboard/dashboard"
      );
      window.location.reload();
    }
  }, [location]);

  const isAuthenticated = !!Cookies.get("token");

  const DashboardLayout = () => {
    if (!isAuthenticated) {
      return <Navigate to="/" replace />;
    }

    return (
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1 className="h2">
                {location.pathname.includes("tasks")
                  ? "Tasks"
                  : location.pathname.includes("calendar")
                  ? "Calendar"
                  : "Task Dashboard"}
              </h1>
              <div className="fw-bold text-muted">
                {user ? `Welcome, ${user.name}` : ""}
              </div>
            </div>
            <Toaster />
            <Outlet />
          </main>
        </div>
      </div>
    );
  };

  return (
    <Routes>
      <Route path="/" element={<Auth />} />
      <Route path="/slack/dashboard" element={<DashboardLayout />}>
        <Route index element={<Navigate to="tasks" replace />} />
        <Route path="dashboard" element={<DashboardHome />} />
        <Route path="tasks" element={<TaskTable />} />
        <Route path="calendar" element={<AuthCalendar />} />
      </Route>
      {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
    </Routes>
  );
}

export default App;
